import React from 'react';

import AudioSection from '@components/pages/DualSubscribe/AudioSection';
import TITVSection from '@components/pages/DualSubscribe/TITVSection';
import AppsCluster from '@components/pages/SubscribeTest/OfferSelection/Clusters/AppsCluster';
import EventCluster from '@components/pages/SubscribeTest/OfferSelection/Clusters/EventCluster';

const BenefitCluster = ({ latestTITVEpisodeID }: { latestTITVEpisodeID?: string }) => {
  return (
    <article className="relative flex w-full flex-col gap-80 sm:gap-112">
      <div className="grid grid-cols-1 gap-80 lg:grid-cols-2 lg:gap-x-48 lg:gap-y-112">
        <TITVSection
          className="flex flex-col justify-between pb-12"
          latestTITVEpisodeID={latestTITVEpisodeID}
        />
        <EventCluster />
      </div>
      <div className="border border-x-0 border-b border-t-0 border-solid border-grayscale-gray">
        <AppsCluster className="pb-0 lg:pb-80" />
      </div>
      <AudioSection mainContainerClassName="!pt-0" />
    </article>
  );
};

export default BenefitCluster;
